import axios from "axios"


const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

// Add Policy-Type like health insurance, Life insurance etc...
export const getKnowledgeCenterAPI = async payload => {
  try {

    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/get-KnowledgeCenterfiles`, payload, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error Gettting Knowledge Center Files:", error)
    throw error
  }
}




export const getCompanyKnowledgeGuideAPI = async payload => {
  try {

    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.get(`${apiBaseUrl}/get-CompanyKnowledgeGuide`, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error Gettting Company Knowledge guide: ", error)
    throw error
  }
}




export const getKnowledgeGuideLinksAPI = async payload => {
  try {

    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.get(`${apiBaseUrl}/get-KnowledgeGuideLink`, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error Gettting Company Knowledge guide Links: ", error)
    throw error
  }
}